"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = void 0;

function parse(millisOrString) {
  if (typeof millisOrString === 'number') {
    return millisOrString;
  }

  var timestamp = Number(millisOrString) || Date.parse(millisOrString);

  if (Number.isInteger(timestamp)) {
    return timestamp;
  }

  throw new Error("Invalid timestamp: ".concat(millisOrString));
}

exports.default = parse;
exports.parse = parse;